// Single source of truth for the Everything & Anything hub.
// Used by EverythingHome (the hub) and — eventually — anything else that needs
// the card catalog so labels, art, and routes live in one place.
//
// Each entry:
//   id           — slug used for access checks (EverythingCardAccess.cardId)
//   name         — display label on the card
//   description  — short blurb (~12 words) shown on the card
//   category     — section the card renders under (see CATEGORY_ORDER)
//   Icon         — Lucide component, gradient-tile fallback when image is missing
//   accent       — { from, to } gradient stops for the fallback art tile
//   image        — /public path; null falls back to the accent gradient + Icon
//   imageClass   — extra object-position class for the art crop
//   route        — where the card navigates on click

import { Flag } from 'lucide-react';

const CARDS = [
  {
    id: 'production-flag-tracker',
    name: 'Production Flag Tracker',
    description: 'Live count of VIP production-flag notifications across tracked Slack channels.',
    category: 'Monitoring',
    Icon: Flag,
    accent: { from: '#f59e0b', to: '#b45309' },
    image: '/tool-cards/production-flag-tracker.webp',
    imageClass: 'object-top',
    route: '/everything/production-flag-tracker',
  },
];

// Categories render in this order; unknown categories are appended alphabetically.
export const CATEGORY_ORDER = ['Monitoring'];

export default CARDS;
